import { CustomModal, Divider } from "@components"

import {
  Button, 
  ModalContent, 
  ModalHeader, 
  ModalBody, 
  ModalFooter,
} from "@heroui/react"

import PropTypes from 'prop-types'

const OpenToParentsModal = ({ 
  handleCancel, 
  handleOpenToParents, 
  orphanedStudents, 
  show 
}) => {  
  const closeModal = () => {
    handleCancel()
  }

  return (
    <CustomModal
      isOpen={show}
      size="xl"
      handleClose={closeModal}
      scrollBehavior="outside"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader>Open Event To Parents</ModalHeader>
          
            <ModalBody>
              <div>
                <h1 className="text-lg font-semibold">Are you sure you want to open this event to parents?</h1>
                <p className="text-content2-foreground">You have {orphanedStudents.length} {orphanedStudents.length === 1 ? 'student' : 'students'} that have no guardians invited to this event. To associate guardians to these students visit the invitations page and view unmatched.</p>

                <Divider className="my-3" />

                {orphanedStudents.length > 0 && (
                  <ul className="overflow-y-auto list-disc list-inside max-h-96">
                    {orphanedStudents.map((student) => (
                      <li key={student.id}>{student.forename} {student.surname}</li>
                    ))}
                  </ul>
                )}
              </div>
            </ModalBody>

            <ModalFooter>
              <div className="flex justify-between w-full">
                <Button onPress={handleCancel} tabIndex={-1}>Cancel</Button>
                <Button className="font-semibold text-white" color="success" onPress={handleOpenToParents} tabIndex={-1}>Open To Parents</Button>
              </div>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </CustomModal>
  )
}

OpenToParentsModal.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleOpenToParents: PropTypes.func.isRequired,
  orphanedStudents: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    forename: PropTypes.string,
    surname: PropTypes.string,
  })),
  show: PropTypes.bool,
}

export default OpenToParentsModal